"use client";

import { useState } from "react";
import styles from "./designGuide.module.css";

type GuideItem = {
  title: string;
  body: string;
};

type GuideSection = {
  key: string;
  tab: string;
  title: string;
  subtitle: string;
  items: GuideItem[];
};

export function DesignGuideTabs({
  sections,
  tabLabel
}: Readonly<{
  sections: GuideSection[];
  tabLabel: string;
}>) {
  const [activeIndex, setActiveIndex] = useState(0);
  let imageIndex = 0;

  return (
    <div id="dao" className={styles.dao}>
      <nav className={styles.tabs} aria-label={tabLabel}>
        {sections.map((section, index) => (
          <button
            key={section.key}
            type="button"
            className={index === activeIndex ? styles.activeTab : ""}
            onMouseEnter={() => setActiveIndex(index)}
            onFocus={() => setActiveIndex(index)}
            onClick={() => setActiveIndex(index)}
            aria-pressed={index === activeIndex}
          >
            {section.tab}
          </button>
        ))}
      </nav>

      <div className={styles.panels}>
        {sections.map((section, index) => {
          const startImage = imageIndex + 1;
          imageIndex += section.items.length;

          return (
            <section
              key={section.key}
              className={`${styles.panel} ${index === activeIndex ? styles.activePanel : ""}`}
              aria-hidden={index !== activeIndex}
            >
              <h1>{section.title}</h1>
              <h2>{section.subtitle}</h2>

              {section.items.map((item, itemIndex) => (
                <article key={item.title} className={styles.guideRow}>
                  <div className={styles.imageWrap}>
                    <img src={`/images/dao${startImage + itemIndex}.png`} alt="" />
                  </div>
                  <div className={styles.copy}>
                    <img className={styles.arrow} src="/images/rawright.png" alt="" />
                    <h3>{item.title}</h3>
                    <p>{item.body}</p>
                  </div>
                </article>
              ))}
            </section>
          );
        })}
      </div>
    </div>
  );
}
